import Vue from 'vue'
import Router from 'vue-router'
import ManagementControl from '@/router/ManagementControl.js'
import ManagementFee from '@/router/ManagementFee.js'
import ManagementFeeKGI from '@/router/ManagementFeeKGI.js'
import News from '@/router/News.js'
import Rules from '@/router/Rules.js'
import Calendar from '@/router/Calendar.js'
import Guest from '@/router/Guest.js'
import Message from '@/router/Message.js'
import CommunityGas from '@/router/CommunityGas.js'
import AccountManagement from '@/router/AccountManagement.js'
import VisitorRealNameRigistration from './router/VisitorRealNameRigistration'
import Vote from './router/Vote'
import Intercom from './router/Intercom'
import AttendanceManagement from '@/router/AttendanceManagement.js'
import UnitOwnerAssembly from '@/router/UnitOwnerAssembly.js'
import DeviceManagement from '@/router/DeviceManagement.js'
import Bulletin from '@/router/Bulletin.js'
import Asset from '@/router/Asset.js'
import BAAlert from './router/BA-alert'
import BAHome from './router/BAHome'
import Supplier from './router/Supplier'
import SupplierMaintenance from './router/SupplierMaintenance'
import Household from './router/Household'
import Postal from './router/Postal'
import Property from './router/Property'
import Point from './router/Point'
import CollectionPayment from './router/CollectionPayment'
import Backdoor from './router/Backdoor'
import EvCharging from './router/EvCharging'
import SmartLocker from './router/SmartLocker'
import { checkPathIsNoNeedToLogin } from './js/utils'
import * as Sentry from '@sentry/vue'

// import { Message } from 'element-ui'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'development' ? '/' : '/mgmt/',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    // {
    //   path: '/main',
    //   name: 'Main',
    //   component: () => import('@/views/Main/Main.vue')
    // },
    {
      path: '/login',
      name: 'LoginMain',
      component: () => import('@/views/LoginMain.vue'),
      meta: {
        header: 'none',
        footer: 'none',
        logoutinfo: 'none'
      }
    },
    {
      path: '/register',
      name: 'LoginMainRegister',
      component: () => import('@/views/LoginMain.vue'),
      meta: {
        header: 'none',
        footer: 'none',
        logoutinfo: 'none'
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/Main/Main.vue')
    },
    {
      path: '/postalPatch',
      name: 'postalPatch',
      component: () => import('@/components/Layer.vue'),
      children: [
        {
          path: '',
          name: 'postalPatchList',
          component: () => import('@/views/PostalPatch/PostalPatchList.vue'),
          meta: {
            prev: 'goHome'
          }
        }
      ]
    },
    {
      path: '/SystemUpdates',
      component: () => import('@/components/Layer.vue'),
      children: [
        {
          path: '',
          name: 'SystemUpdates',
          component: () => import('@/views/SystemUpdates/SystemUpdates.vue'),
          meta: {
            prev: 'goHome',
            keepAlive: true
          }
        },
        {
          path: '/SystemUpdatesDetail/:id',
          name: 'SystemUpdatesDetail',
          component: () => import('@/views/SystemUpdates/SystemUpdatesDetail.vue'),
          meta: {
            prev: 'SystemUpdates'
          }
        }
      ]
    },
    {
      path: '/lastLoginInformation',
      component: () => import('@/views/lastLoginInformation.vue')
    },
    { // 物業專屬優惠
      path: '/Staffonly',
      name: 'Staffonly',
      component: () => import('@/views/Staffonly.vue'),
      meta: {
        prev: 'goHome'
      }
    },
    ...ManagementControl,
    ...ManagementFee,
    ...ManagementFeeKGI,
    ...News,
    ...Rules,
    ...Calendar,
    ...Message,
    ...CommunityGas,
    ...AccountManagement,
    ...VisitorRealNameRigistration,
    ...Guest,
    ...Vote,
    ...Intercom,
    ...AttendanceManagement,
    ...UnitOwnerAssembly,
    ...DeviceManagement,
    ...Bulletin,
    ...Asset,
    ...BAAlert,
    ...BAHome,
    ...Supplier,
    ...Household,
    ...Property,
    ...SupplierMaintenance,
    ...Household,
    ...Point,
    ...Postal,
    ...CollectionPayment,
    ...Backdoor,
    ...EvCharging,
    ...SmartLocker,
    {
      path: '*',
      name: 'error',
      component: () => import('@/views/error.vue'),
      meta: {
        prev: 'goHome',
        footer: 'none'
      }
    }
  ]
})

// 路由守衛
router.beforeEach((to, from, next) => {
  setSentryInfo()

  // 針對 管理費 會有開啟有多個費用管理，會需要去設定前一頁是管理費管理頁面“ManagementControl”
  const updateFeePrevMeta = (type) => {
    if (type === 'other-management' || type === 'management') {
      return 'ManagementControl'
    }
    return 'goHome'
  }
  // 判斷 路徑並設置 meta.prev (詳細type 請見route 內容註解)
  if (/^\/fee(\/|$)|^\/fee-kgi(\/|$)/.test(to.path)) {
    const type = to.params.type
    to.meta.prev = updateFeePrevMeta(type)
  }
  const HASH_MODE_PREFIX = new RegExp('^/login#/')
  // HASH_MODE_PREFIX 為 login 開頭的原因為 router.js 裡面 '/' 都會先被轉址至 '/login/'
  if (to.fullPath.match(HASH_MODE_PREFIX)) {
    // 1. 若是以往使用的 hash mode 路徑則調整為 history mode，以支援向下相容
    // e.g. /#/news to /news
    const redirectToHistoryMode = () => {
      const newPath = to.fullPath.replace(HASH_MODE_PREFIX, '/')
      // 將帶有 HASH_MODE_PREFIX 的部分替換為不帶 HASH_MODE_PREFIX 的路徑
      next({ path: newPath })
      // 重新導向至預期路徑
    }
    redirectToHistoryMode()
  } else if (checkPathIsNoNeedToLogin(to.fullPath)) {
    // 2. 預期頁面不需登入則不進行驗證，直接進入
    // e.g. /home
    next()
  } else {
    // 3. 預期頁面需登入則驗證登入狀態，通過則進入、失敗則提示
    const enterDirectlyOrValidateLoginStatus = () => {
      try {
        const checkIsLoginValid = () => {
          // 必須有登入資訊、登入狀態、過期時間
          const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'))
          const loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
          const expireTime = new Date(loginUserInfo.ExpireTime)
          // 判斷是否過期
          const isValidLoginTime = new Date() < expireTime
          const isComLoginToken = Vue.prototype.$getCookie('comLoginToken')
          return loginUserInfo && loginStatus && isValidLoginTime && isComLoginToken
        }
        // 登入狀態合理則導至其頁面，否則請使用者重新登入
        if (checkIsLoginValid()) {
          next()
        } else {
          throw new Error('登入過期或驗證失敗，請重新登入')
        }
      } catch (error) {
        // 登入過期或驗證失敗，需重新登入
        const showReLoginAlert = () => {
          Vue.prototype.$alert('登入過期或驗證失敗，請重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            // 登出登乾淨
            Vue.prototype.$logoutCommunity()
          })
        }
        showReLoginAlert()
      }
    }
    enterDirectlyOrValidateLoginStatus()
  }
})

// 避免重新導向至同一頁面所產生的錯誤，因不影響使用者、故全域 catch 錯誤即可 (#77131)
const originalPush = router.push
router.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const setSentryInfo = () => {
  try {
    const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo')) || {}
    Sentry.setTag('comId', loginUserInfo.ComId || '無')
    Sentry.setUser({ username: loginUserInfo.AdminName || '無' })
  } catch {
    // 不特別處理 Sentry 錯誤情況
    // 加上 try catch，避免錯誤影響後續流程
  }
}
export default router
